module.exports = __webpack_public_path__ + "static/media/Cooked_lox_meat.9180ac7c.png";